import { Box, useTheme } from "@mui/material";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";

import { AllApprovedPayrollQuery, AllPayrollQuery } from "../../../../data/Queries/HRmanagement/leavemanagement";
import PayrollRunCreationForm from "../form";
import { PayrollColumns } from "../../../../data/Columns/hrmanagement";
import { tokens } from "../../../../theme";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { HRService } from "../../../../config";


const base_url = HRService.uri;

const PayrollApprovedTable = () => {
  const actions = {
    entity: "Payroll",
    // edit: {
    //   key: "EDIT",
    //   button_name: "Edit",
    //   Show_Button: true,
    //   permission: "EditPermission",
    // },
    // add: {
    //   key: "ADD",
    //   button_name: "Add",
    //   Show_Button: true,
    //   permission: "CreatePermission",
    //   inputObjectName: "createCaseDynamic",
    //   InputObject: "newCase",
    // },
    // activateDeactivate: {
    //   key: "ACTIVATEDEACTIVATE",
    //   button_name: "Deactivate",
    //   Show_Button: false,
    //   permission: "ActivatePermission",
    // },
    ViewPayrollLines: {
      key: "VIEWPAYROLLLINES",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },

     // ---------- APPROVE ----------
//   APPROVEPAYROLL: {
//     key: "ApprovePayroll",
//     button_name: "Run payroll",
//     Show_Button: true,
//     permission: "hasNoPermission",
//     roleGroupId: [1, 2, 3, 4],
//   },
  CLOSEPAYROLL: {
    key: "ClosePayroll",
    button_name: "Close",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
//   POSTPAYROLL: {
//     key: "PostPayroll",
//     button_name: "Post To GL",
//     Show_Button: true,
//     permission: "hasNoPermission",
//     roleGroupId: [1, 2, 3, 4],
//   },
  

    showStatus: true,
  };
  const [data, setData] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
 
  return (
    <Box m="2px">
      <>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          
        </Box>
        <DynamicTable
          title="Payroll"
          subtitle="View all Payroll, create or update a employee"
          columns={PayrollColumns}
          FormComponent={PayrollRunCreationForm}
          query={AllApprovedPayrollQuery}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
};

export default PayrollApprovedTable;
